import React, {ReactNode} from 'react';
import {Card, makeStyles} from '@material-ui/core';

type CardProps = {
  children: ReactNode;
  className?: string;
  title: string | JSX.Element;
};

const useCardStyles = makeStyles(() => ({
  card: {
    marginBottom: '1rem',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
  },
  header: {
    backgroundColor: '#f1f1f1',
    color: '#0033A0',
    width: '100%',
    fontWeight: 600,
    textAlign: 'left',
    borderBottom: '1px solid #ccc',
    padding: '1.25rem 1.75rem',
  },
  title: {
    fontSize: '1.10rem',
    margin: '0',
  },
}));

export const AllstateCardV2 = (props: CardProps) => {
  const classes = useCardStyles();
  return (
    <Card className={classes.card} elevation={3}>
      <div className={classes.header}>
        {React.isValidElement(props.title) ? <>{props.title}</> : <h2 className={classes.title}>{props.title}</h2>}
      </div>
      <div className={props.className ? props.className : 'card__body'}>{props.children}</div>
    </Card>
  );
};
